




















    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { VFields } from '@/models/v-fields';
    import { Lane } from '@/models/admin/lane';
    import { Base } from '@/components/common/base';
    import {laneService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

    @Component({
        props: ['methodName', 'progress'],
        computed: {
            methodtoCall: {
                get() {
                    return this.$props.methodName;
                },
            },
        },
    })
    export default class LaneSavePage extends Base {
        public stores: any[];
        public lane: Lane = {
            laneId: 0,
            terminalId: '',
            serialNumber: '',
            description: '',
            activationCode: '',
            marketCode: 0,
            isActivated: false,
            storeDealershipName: '',
            paymentAccountType: '',
        };

        public form: any = {};
        public formFields: Array<VFields<any>> = [];
        public storeId: number = 0;
        public paymentTypes: any[];
        public disableSubmitButton: boolean = false;

        public beforeDestroy() {
            const buttons = [];
            this.$emit('updateToolBar', buttons);
        }
        public callMethod(methodName): void {
            if (methodName === 'backToList') {
                this.$router.push({ name: 'admin.lanes', params: { storeId: this.storeId.toString() } });
            }
            if (methodName === 'submit') {
                if (!this.form.$valid) {
                    this.showAlert(false, 'Form is Invalid!');
                    this.resetMethodName(methodName);
                    return;
                }
                this.submitLane();
            }
            this.resetMethodName(methodName);
        }
        public resetMethodName(methodName): void {
            if (methodName !== '') {
                this.$emit('resetMethodName', methodName);
            }
        }
        public updateToolBar(): void {
            const buttons: any = [];
            buttons.push({ id: '0', type: 'button', title: this.$parent.$t('lanes.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('lanes.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
            this.$emit('updateToolBar', buttons);
        }
        public async mounted(): Promise<void> {
            // activating tab
            this.$root.$emit('sidebar.layout.vue', 'lanes');

            this.storeId = Number(this.$route.params.storeId);
            this.setFields();

            this.updateToolBar();
            this.$watch('methodtoCall', (newVal, oldVal) => {
                if (newVal) {
                    this.callMethod(newVal);
                }
            });

            if (this.$route.params.id) {
                const lane = await laneService.getLaneByIdAsync(
                    Number(this.$route.params.id),
                    this.storeId,
                );
                this.lane = lane;
            }
            this.getPaymentTypes();
        }

        public validateLane(): Vue & { validate: () => boolean } {
            return this.$refs.laneForm as Vue & { validate: () => boolean };
        }

        public async submitLane(): Promise<void> {
            if(this.validateLane().validate()){
                try {
                    this.disableSubmitButton = true;
                    this.$emit('update:progress', this.disableSubmitButton);
                    if (this.$route.params.id) {
                        await laneService.updateAsync(this.lane, this.storeId);
                        this.showAlert(true, this.$t('lanes.alertUpdateLane'));
                        this.$router.push({
                            name: 'admin.lanes',
                            params: { storeId: this.storeId.toString() },
                        });
                    } else {
                        await laneService.addAsync(this.lane, this.storeId);
                        this.showAlert(true, this.$t('lanes.alertSaveLane'));
                        this.$router.push({
                            name: 'admin.lanes',
                            params: { storeId: this.storeId.toString() },
                        });
                    }
                } finally {
                    this.disableSubmitButton = false;
                    this.$emit('update:progress', this.disableSubmitButton);
                }
            }
        }
        public setFields(): void {
            this.formFields = [
                {
                    key: 'paymentAccountType',
                    type: 'v-alynk-select',
                    required: true,
                    templateOptions: {
                        label: this.$t('lanes.laneFields.paymentDepartment') as string,
                        required: true,
                        disabled: false,
                        items: this.paymentTypes,
                        text: 'description',
                        value: 'text',
                        altag: 'Payment Department',
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        rules:[
                            v => this.required('Payment Department',v)
                        ]
                    },
                },
                {
                    key: 'LaneId',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 10,
                        label: this.$t('lanes.laneFields.laneId') as string,
                        required: true,
                        disabled: false,
                        time: true,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        rules:[
                            v => this.required('Lane Id', v)
                        ]
                    },
                },
                {
                    key: 'terminalId',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 20,
                        label: this.$t('lanes.laneFields.terminalId') as string,
                        required: true,
                        disabled: false,
                        time: true,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        rules:[
                            v => this.required('Terminal Id',v)
                        ]
                    },
                },
                {
                    key: 'serialNumber',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 50,
                        label: this.$t('lanes.laneFields.serialNumber') as string,
                        required: false,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                    },
                },
                {
                    key: 'description',
                    type: 'v-alynk-textarea',
                    required: true,
                    templateOptions: {
                        counter: 250,
                        label: this.$t('lanes.laneFields.description') as string,
                        required: false,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                    },
                },
                {
                    key: 'marketCode',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 3,
                        label: this.$t('lanes.laneFields.marketCode') as string,
                        required: false,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                    },
                },
                {
                    key: 'activationCode',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 20,
                        label: this.$t('lanes.laneFields.activationCode') as string,
                        required: false,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                    },
                },
            ];
        }

        public async getPaymentTypes(): Promise<void> {
            try {
                this.formlyShowSkeleton(this.formFields, 'paymentAccountType');
                const paymentTypes = await laneService.getPaymentTypesAsync();
                this.paymentTypes = paymentTypes.results;
                this.setFields();
            } finally {
                this.formlyHideSkeleton(this.formFields, 'paymentAccountType');
            }
        }
    }
